import moment from "moment";
const getOption = (data1: Array<number>, type: string): any => {
  const x: string[] = [];
  const y: number[] = [];
  const days: string[] = [];
  let stationName: string = "";
  data1.forEach((e: any) => {
    x.push(
      moment(e.datetime, "YYYYMMDDHHmmss")
        .add(8, 'hour')
        .format("DD日HH") + "时"
    );
    y.push(Math.round(e.pre_1h * 10) / 10);
    stationName = e.stationName;
  });

  const fontSize = 14;

  let leftPostion = 15;
  let topPostion = 30;
  let yAxisShow = false;
  let splitLine = false;
  let showAllSymbol = false;
  let titleShow = false;
  let xInterval = 5;
  let xLabelFormat = undefined;
  let bottomPostion = 35;
  let dataZoomDisAble = false;
  let dataZoom = 100;
  let tooltipShow = false;
  if (type === "full") {
    leftPostion = 35;
    topPostion = 40;
    titleShow = true;
    xInterval = 1;
    yAxisShow = true;
    splitLine = true;
    showAllSymbol = true;
    dataZoomDisAble = true;
    dataZoom = 100;
    xLabelFormat = function(value: string) {
      let pattern = new RegExp("[\u4E00-\u9FA5]+");
      const values = value.split("");
      let result = "";
      values.forEach((charValue) => {
        result += charValue;
        if (pattern.test(charValue)) {
          result += "\n";
        }
      });
      return result;
    };
    bottomPostion = 80;
    tooltipShow = true;
  }

  return {
    animation: true,
    title: {
      show: titleShow,
      textStyle: {
        color: "#2D96F7",
      },
      text: stationName + "-过去24小时降水(mm)",
    },
    tooltip: {
      show: tooltipShow,
      trigger: "axis",
    },
    grid: {
      left: leftPostion,
      right: 10,
      top: topPostion,
      bottom: bottomPostion,
    },
    xAxis: {
      type: "category",
      data: x,
      axisLabel: {
        fontFamily: "PingFangSC-Regular",
        interval: xInterval,
        formatter: xLabelFormat,
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "#2D96F7",
        },
      },
      axisTick: {
        show: false,
      },
    },
    dataZoom: [
      {
        type: "inside",
        disabled: !dataZoomDisAble,
        start: 0,
        end: dataZoom,
      },
    ],
    yAxis: {
      show: yAxisShow,
      type: "value",
      min: 0,
      max: (value: any) => Math.round(value.max + 1),
      splitNumber: 1,
      interval: 1,
      splitLine: { show: splitLine },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#2D96F7",
        },
      },
    },
    series: {
      data: y,
      symbol: "circle",
      smooth: true,
      label: {
        show: true,
        color: "#000",
        fontSize,
        position: "top",
      },
      itemStyle: {
        color: "#2D96F7",
      },
      type: "bar",
      yAxisIndex: 0,
    },
  };
};
export default getOption;
